import React from 'react';
import { NotificationManager } from 'react-notifications';
import { validatePhoneNumber } from 'Helpers/Validation';
import NumericStringInput from './NumericStringInput';
import './index.css';
import withViewContext from './withViewContext';

const PhoneNumber = (props) => {
  const verifyPhoneNumberLength = (value) => {
    if (value && !validatePhoneNumber(value)) {
      NotificationManager.warning('Please enter a valid phone number.');
      return false;
    }
    return true;
  };

  return (
    <NumericStringInput
      {...props}
      validation={verifyPhoneNumberLength}
      format="(###) ###-####"
    />
  );
};

export default withViewContext(PhoneNumber);
